// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_footer__8gle9 {
  background-color: #6ba7a8;
  color: #fff;
  padding: 12px;
  display: flex;
  gap: 8px;
  align-items: flex-end;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/footer/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,QAAA;EACA,qBAAA;EACA,uBAAA;AACF","sourcesContent":[".footer {\n  background-color: #6ba7a8;\n  color: #fff;\n  padding: 12px;\n  display: flex;\n  gap: 8px;\n  align-items: flex-end;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `styles_footer__8gle9`
};
export default ___CSS_LOADER_EXPORT___;
